<div class="change-password-wrapper p-3" *ngIf="step === 'otp'">
  <div class="card booking-card">
    <div class="card-header booking-card__header">
      <div>
        <div class="booking-card__eyebrow">Verification Step</div>
        <h4 class="sub-title mb-0">Verify One-Time Pin</h4>
      </div>
    </div>

    <div class="card-body p-4">
      <p class="text-muted small mb-3">
        Please enter the security verification code sent to your registered contact.
      </p>

      <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()">
        <label for="otp" class="form-label">OTP Code</label>
        <input
          id="otp"
          type="text"
          class="form-control mb-2"
          formControlName="otp"
          placeholder="Enter OTP"
        />

        <div
          class="text-danger small mb-3"
          *ngIf="otpForm.controls['otp'].invalid && otpForm.controls['otp'].touched"
        >
          Enter a valid OTP
        </div>

        <button type="submit" class="btn btn-primary" [disabled]="otpForm.invalid">
          <i class="bi bi-shield-check me-1"></i> Continue
        </button>
      </form>
    </div>
  </div>
</div>

<div class="change-password-wrapper p-3" *ngIf="step === 'password'">
  <div class="card booking-card">
    <div class="card-header booking-card__header">
      <div>
        <div class="booking-card__eyebrow">Security Credentials</div>
        <h4 class="sub-title mb-0">Set New Password</h4>
      </div>
    </div>

    <div class="card-body p-4">
      <form [formGroup]="passwordForm" (ngSubmit)="updatePassword()">
        <div class="mb-3">
          <label for="password" class="form-label">New Password</label>
          <input
            id="password"
            type="password"
            class="form-control"
            formControlName="password"
            placeholder="Enter new password"
          />
          <ul class="small mt-2 mb-0 ps-3 list-unstyled" *ngIf="passwordForm.controls['password'].dirty">
            <li [class.text-success]="passwordForm.controls['password'].value?.length >= 8" [class.text-muted]="!(passwordForm.controls['password'].value?.length >= 8)">
              <i class="bi" [class.bi-check-circle-fill]="passwordForm.controls['password'].value?.length >= 8" [class.bi-circle]="!(passwordForm.controls['password'].value?.length >= 8)"></i>
              At least 8 characters
            </li>
            <li [class.text-success]="hasUppercase()" [class.text-muted]="!hasUppercase()">
              <i class="bi" [class.bi-check-circle-fill]="hasUppercase()" [class.bi-circle]="!hasUppercase()"></i>
              At least one uppercase letter
            </li>
            <li [class.text-success]="hasLowercase()" [class.text-muted]="!hasLowercase()">
              <i class="bi" [class.bi-check-circle-fill]="hasLowercase()" [class.bi-circle]="!hasLowercase()"></i>
              At least one lowercase letter
            </li>
            <li [class.text-success]="hasDigit()" [class.text-muted]="!hasDigit()">
              <i class="bi" [class.bi-check-circle-fill]="hasDigit()" [class.bi-circle]="!hasDigit()"></i>
              At least one digit
            </li>
            <li [class.text-success]="hasSpecial()" [class.text-muted]="!hasSpecial()">
              <i class="bi" [class.bi-check-circle-fill]="hasSpecial()" [class.bi-circle]="!hasSpecial()"></i>
              At least one special character (!&#64;#$%...)
            </li>
          </ul>
        </div>

        <div class="mb-3">
          <label for="confirmPassword" class="form-label">Confirm Password</label>
          <input
            id="confirmPassword"
            type="password"
            class="form-control"
            formControlName="confirmPassword"
            placeholder="Confirm new password"
          />

          <div
            class="text-danger small mt-1"
            *ngIf="
              passwordForm.errors?.['passwordMismatch'] &&
              passwordForm.controls['confirmPassword'].touched
            "
          >
            Passwords do not match
          </div>
        </div>

        <button type="submit" class="btn btn-primary" [disabled]="passwordForm.invalid">
          <i class="bi bi-check2-circle me-1"></i> Update Password
        </button>
      </form>
    </div>
  </div>
</div>
